import styles from "./index.module.scss";
import intl from "react-intl-universal";
const MainTitle = ({ title }) => {
	return <div className={styles.titleBox}>{intl.get(title)}</div>
}
export default MainTitle
